import React from 'react';
import classnames from 'classnames';
import {useCompleteInspectionContext} from '../../CompleteInspectionContext';
import styles from './styles.module.scss';
import {getBreakLinesTextShumaType3} from "../../../utils/texts";

export const TextItem19 = React.forwardRef(({className}, ref) => {
  const context = useCompleteInspectionContext();

  return (
    <div ref={ref}>
      {Boolean(context.data.pdfData.buildingPhysicalStateDesc) && (
        <div
          className={classnames(styles.itemText, styles.innerPadding, className)}
        >
          <span className={styles.bold}>הערות כלליות:  </span>
          <span>{getBreakLinesTextShumaType3(context.data.pdfData.buildingPhysicalStateDesc)}</span>
        </div>
      )}
    </div>
  );
});

export default TextItem19;
